import classNames from 'classnames';
import React, { useMemo } from 'react';

import { memoizedComponent } from 'utils/memoizeComponent';

import './index.css';

type Props = {
  initialAmount: number;
  amount: number;
  tooltip?: boolean;
};

function calculateExecutedPercentage(initialAmount: number, leftAmount: number) {
  // Calculate the executed amount
  const executedAmount = initialAmount - leftAmount;

  // Calculate the executed percentage
  const executedPercentage = (executedAmount / initialAmount) * 100;

  return executedPercentage;
}

export const RangeCompletedIndicator: React.FC<React.PropsWithChildren<Props>> = memoizedComponent(
  ({ initialAmount, amount, tooltip = false }) => {
    const rangeCompletedIndicatorClassNames = classNames('range-completed-indicator', {
      'range-completed-indicator--tooltip': tooltip,
    });

    const executedPercentage = useMemo(
      () => calculateExecutedPercentage(initialAmount, amount),
      [amount, initialAmount],
    );

    return (
      <div className={rangeCompletedIndicatorClassNames}>
        <div className='range-completed-indicator__completed' style={{ width: `${executedPercentage}%` }} />
      </div>
    );
  },
);
